<cc-box>
  <div class="container-responsive" header box translate>
    WEBCALL.LIMIT
  </div>
  <div content box>
    <div *ngIf="webcallSummary$ | async as webcallSummary">
      <div class="center">
        <div class="c100 green medium pointer" [ngClass]="'p'+ usedPercentagePointer(webcallSummary)">
          <p class="percent" *ngIf="webcallSummary.webcallLimit">{{usedPercentage(webcallSummary)}}
            %</p>
          <p class="minutes-wrap text-center w-full text-sm" *ngIf="webcallSummary.webcallLimit">
            <span class="used-minutes">{{webcallSummary.webcallUsed}}</span><span>/</span>
            <span class="account-minutes">{{webcallSummary.webcallLimit}}</span>
          </p>
          <p class="percent p-t-sm" translate *ngIf="!webcallSummary.webcallLimit"> WEBCALL.UNLIMITED </p>
          <p class="minutes-wrap text-center w-full text-sm" *ngIf="!webcallSummary.webcallLimit">
            <span translate class="w-full clear"> WEBCALL.VALUE </span>
          </p>
          <div class="slice">
            <div class="bar"></div>
            <div class="fill"></div>
          </div>
        </div>
      </div>


      <div class="row-summary">
        <div class="row">
          <div class="left" translate>WEBCALL.TODAY</div>
          <div class="right price-big">
            {{webcallSummary.webcallUsedToday}}
          </div>
        </div>
      </div>
    </div>

  </div>
</cc-box>
